import { jsx as C, jsxs as l } from "react/jsx-runtime";
import { ICONS_COLOR_MAPPING as t } from "./index.es2447.js";
const d = ({ outline: i = "default-gray" }) => {
  const e = t[i];
  return /* @__PURE__ */ C(
    "svg",
    {
      width: "18",
      height: "18",
      viewBox: "0 0 18 18",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ C("g", { id: "State=Hidden", children: /* @__PURE__ */ l("g", { id: "××××××§", children: [
        /* @__PURE__ */ C(
          "path",
          {
            fill: e,
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M14.8164 2.11214C15.0117 2.30741 15.0117 2.62399 14.8164 2.81925L2.88627 14.7494C2.69101 14.9447 2.37442 14.9447 2.17916 14.7494C1.9839 14.5542 1.9839 14.2376 2.17916 14.0423L3.05572 13.1658C1.99575 12.0858 0.977178 10.6973 0 9.00018C2.687 4.33352 5.687 2.00018 9 2.00018C10.3866 2.00018 11.7183 2.40889 12.9952 3.22629L14.1093 2.11214C14.3046 1.91688 14.6212 1.91688 14.8164 2.11214ZM12.4507 3.77081C11.4102 3.13461 10.3408 2.79804 9.24259 2.75493L9 2.75018C6.16434 2.75018 3.51833 4.68898 1.06808 8.67164L0.869 8.99998L1.06808 9.32873C1.88548 10.6573 2.72466 11.7585 3.5854 12.6361L5.42504 10.7964C5.15312 10.2563 5 9.64605 5 9C5 6.79067 6.79067 5 9 5C9.64605 5 10.2563 5.15312 10.7964 5.42504L12.4507 3.77081Z"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            fill: e,
            d: "M6.75178 12.309C7.39247 12.7451 8.16643 13 9 13C11.2093 13 13 11.2093 13 9C13 8.16643 12.7451 7.39247 12.309 6.75178L6.75178 12.309Z"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            fill: e,
            d: "M5.11517 13.9455C6.29163 14.766 7.50589 15.1963 8.75741 15.2454L9 15.2502C11.8357 15.2502 14.4817 13.3114 16.9319 9.32873L17.13 8.99998L16.9319 8.67164C16.0001 7.15702 15.0399 5.93801 14.0518 5.00883L14.5818 4.47885C15.7725 5.60335 16.9119 7.11046 18 9.00018C15.313 13.6668 12.313 16.0002 9 16.0002C7.45789 16.0002 5.98359 15.4946 4.57712 14.4835L5.11517 13.9455Z"
          }
        )
      ] }) })
    }
  );
};
d.__tags = ["eye", "hide"];
export {
  d as UtilityEyeHideIcon
};
//# sourceMappingURL=index.es440.js.map
